/**
 * Conditional Variant Display
 * Hides "COLOR OF THE STRING" option when "NO STRING" is selected for "ADD A STRING"
 */

(function() {
  'use strict';

  const CONFIG = {
    triggerOptionName: 'ADD A STRING',
    triggerValue: 'NO STRING',
    hiddenOptionName: 'COLOR OF THE STRING',
    defaultHiddenValue: 'BLACK AND GREEN'
  };

  function normalizeString(str) {
    return String(str || '').trim().toUpperCase();
  }

  function getSelectedValue(optionElement) {
    const select = optionElement.querySelector('select');
    if (select) {
      return select.value;
    }

    const checkedInput = optionElement.querySelector('input[type="radio"]:checked');
    if (checkedInput) {
      return checkedInput.value;
    }

    return '';
  }

  function setDefaultValue(optionElement, defaultValue) {
    const normalizedDefault = normalizeString(defaultValue);

    const select = optionElement.querySelector('select');
    if (select) {
      const options = Array.from(select.options);
      const matchingOption = options.find(opt => normalizeString(opt.value) === normalizedDefault);
      if (matchingOption) {
        select.value = matchingOption.value;
        matchingOption.setAttribute('selected', 'selected');
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const radioInputs = optionElement.querySelectorAll('input[type="radio"]');
    radioInputs.forEach(input => {
      if (normalizeString(input.value) === normalizedDefault) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function updateConditionalDisplay(variantSelects) {
    const allOptions = variantSelects.querySelectorAll('.product-form__input, fieldset.product-form__input, div.product-form__input');

    let triggerOption = null;
    let hiddenOption = null;

    allOptions.forEach((option) => {
      const label = option.querySelector('.form__label, legend');
      if (label) {
        const labelText = label.textContent.replace(':', '').trim();
        const normalizedLabel = normalizeString(labelText);

        if (normalizedLabel === normalizeString(CONFIG.triggerOptionName)) {
          triggerOption = option;
        } else if (normalizedLabel === normalizeString(CONFIG.hiddenOptionName)) {
          hiddenOption = option;
        }
      }
    });

    if (!triggerOption || !hiddenOption) {
      return;
    }

    const selectedValue = getSelectedValue(triggerOption);
    const shouldHide = normalizeString(selectedValue) === normalizeString(CONFIG.triggerValue);

    if (shouldHide) {
      const currentHiddenValue = getSelectedValue(hiddenOption);

      if (normalizeString(currentHiddenValue) !== normalizeString(CONFIG.defaultHiddenValue)) {
        setDefaultValue(hiddenOption, CONFIG.defaultHiddenValue);
      }

      hiddenOption.style.display = 'none';
      hiddenOption.setAttribute('data-conditionally-hidden', 'true');
    } else {
      hiddenOption.style.display = '';
      hiddenOption.removeAttribute('data-conditionally-hidden');
    }
  }

  function watchProductInfo() {
    const productInfoElements = document.querySelectorAll('product-info');

    productInfoElements.forEach(productInfo => {
      const observer = new MutationObserver(function() {
        const variantSelects = productInfo.querySelectorAll('variant-selects');
        variantSelects.forEach(vs => {
          updateConditionalDisplay(vs);
        });
      });

      observer.observe(productInfo, {
        childList: true,
        subtree: true
      });
    });
  }

  function initializeConditionalDisplay(variantSelects) {
    setTimeout(() => {
      updateConditionalDisplay(variantSelects);
    }, 100);

    variantSelects.addEventListener('change', function() {
      requestAnimationFrame(() => {
        updateConditionalDisplay(variantSelects);
      });
    });
  }

  function init() {
    const variantSelects = document.querySelectorAll('variant-selects');

    variantSelects.forEach((element) => {
      initializeConditionalDisplay(element);
    });

    watchProductInfo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });

  document.addEventListener('product-info:loaded', function() {
    setTimeout(init, 200);
  });
})();
